import { Grid } from '@mui/material';
import InformationCollecting from '../../../components/InformationCollecting';
import SalesConditions from '../../../components/SalesConditions';
import { CitysprintReviewShippingCard } from './CitysprintReviewShippingCard';

export function CitysprintReviewBookPanels({
  data,
  onAcceptTerms,
  salesConditionsLink,
  deliveryCountryName,
  collectionSchedule,
}) {
  return (
    <>
      <CitysprintReviewShippingCard
        data={data}
        collectionSchedule={collectionSchedule}
      />
      <Grid sx={{ mt: 2 }} size={12}>
        <SalesConditions
          onAcceptTerms={onAcceptTerms}
          salesConditionsLink={salesConditionsLink}
          deliveryCountryName={deliveryCountryName}
          isAvailableProhibitedCondition={false}
          showProhibitedItemsBullet={false}
          showDutyAndTaxInformation={false}
          showOrderPlacementBulletList={false}
        />
        <InformationCollecting
          sx={{
            px: { xs: 3, md: 0 },
          }}
        />
      </Grid>
    </>
  );
}
